module.exports = __webpack_public_path__ + "img/photo-15.0435960a.jpg";